import { DialogMessagePlaceholders } from 'src/app/notifications/dialogs/dialog-message/dialog-message-placeholders.model';

export const COMMENT_PLACEHOLDER_PHRASES: DialogMessagePlaceholders = {
  inputPlaceholder: 'POSTS_POST_DETAIL_INFO_NEW_COMMENT_PLACEHOLDER',
  maxLengthErrorHint: 'POSTS_POST_DETAIL_INFO_NEW_COMMENT_ERROR_HINT',
  emptyErrorHint: 'POSTS_POST_DETAIL_INFO_EMPTY_ERROR_HINT',
  buttonHint: 'POSTS_POST_DETAIL_INFO_NEW_COMMENT_BTN_SEND_HINT',
  typingHint: '',
};
